import { render, staticRenderFns } from "./QaSearchList.vue?vue&type=template&id=76b3da74&scoped=true&"
import script from "@/scripts/QA/QuestionList/components/QaSearchList?vue&type=script&lang=js&"
export * from "@/scripts/QA/QuestionList/components/QaSearchList?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b3da74",
  null
  
)

export default component.exports